import {useEffect, useState} from 'react'

// echtes Vollbild des Browsers (ohne Tabs, Adressleiste, Menü, ...), ältere Safari-Versionen (z.B. iPad) nur mit webkit-Präfix.
// Nicht jeder Browser unterstützt es (z.B. iPhone), dann bleibt es bei der Überlagerung innerhalb der Seite.
const getFullscreenElement = () => document.fullscreenElement || document.webkitFullscreenElement;

/**
 * Schaltet das echte Vollbild des Browsers ein. Muss direkt im Klick aufgerufen werden.
 * Es geht die ganze Seite ins Vollbild, damit auch Overlays von PrimeReact (an body gehängt) sichtbar bleiben.
 */
export const starteBrowserVollbild = () => {
    const element = document.documentElement;
    try {
        if (element.requestFullscreen) {
            element.requestFullscreen().catch(() => {});
        } else if (element.webkitRequestFullscreen) {
            element.webkitRequestFullscreen();
        }
    } catch (e) {
        // ohne Vollbild bleibt es bei der Überlagerung
    }
}

export const beendeBrowserVollbild = () => {
    if (!getFullscreenElement()) {
        return;
    }
    try {
        if (document.exitFullscreen) {
            document.exitFullscreen().catch(() => {});
        } else if (document.webkitExitFullscreen) {
            document.webkitExitFullscreen();
        }
    } catch (e) {
        // nichts zu tun
    }
}

/**
 * Zustand der Vollbildansichten im neuen Design (Turnierbaum, alle Bäume, Gruppen, Live, ...).
 * Im Vollbild wird die Ansicht über die ganze Seite gelegt, die Seite dahinter scrollt nicht mit, Escape schließt,
 * und außerhalb der App wird zusätzlich das echte Vollbild des Browsers eingeschaltet. Beendet der Benutzer das
 * Vollbild des Browsers (Escape, F11, ...), wird auch die Ansicht geschlossen, und umgekehrt.
 *
 * @param appCall in der App kein Vollbild des Browsers
 * @returns [vollbild, starteVollbild, schliesseVollbild]
 */
export function useVollbild(appCall) {

    const [vollbild, setVollbild] = useState(false);

    useEffect(() => {
        if (!vollbild) {
            return;
        }
        const overflowVorher = document.body.style.overflow;
        document.body.style.overflow = "hidden";
        const handleKeyDown = (event) => {
            if (event.key === "Escape") {
                setVollbild(false);
            }
        };
        const handleFullscreenChange = () => {
            if (!getFullscreenElement()) {
                setVollbild(false);
            }
        };
        document.addEventListener("keydown", handleKeyDown);
        document.addEventListener("fullscreenchange", handleFullscreenChange);
        document.addEventListener("webkitfullscreenchange", handleFullscreenChange);
        return () => {
            document.body.style.overflow = overflowVorher;
            document.removeEventListener("keydown", handleKeyDown);
            document.removeEventListener("fullscreenchange", handleFullscreenChange);
            document.removeEventListener("webkitfullscreenchange", handleFullscreenChange);
            beendeBrowserVollbild();
        };
    }, [vollbild]);

    const starteVollbild = () => {
        setVollbild(true);
        if (!appCall) {
            starteBrowserVollbild();
        }
    }

    const schliesseVollbild = () => setVollbild(false);

    return [vollbild, starteVollbild, schliesseVollbild];
}
